import { Button, Input, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useInquiryStore } from '@/store';
import { useEffect, useState } from 'react';
import { useDebounceValue } from '@/hooks';
import { inquiryStatusOption } from '@/utils';

export const InquiryFilter = () => {
  const { filter, setParams } = useInquiryStore();
  const [searchText, setSearchText] = useState('');

  const [debouncedValue] = useDebounceValue(searchText, 500);

  useEffect(() => {
    setParams({ page: 1, search: debouncedValue });
  }, [debouncedValue]);

  return (
    <div className='flex justify-start gap-[6px] items-center'>
      <Input
        className='w-[300px]'
        prefix={<SearchOutlined className='text-[20px]' />}
        placeholder=''
        value={searchText}
        onChange={(e) => {
          setSearchText(e.target.value);
        }}
      />
      <Select
        className='select-status-banner'
        defaultValue={null}
        onChange={(status) => setParams({ status, page: 1 })}
        options={inquiryStatusOption}
        value={filter.status}
        placeholder='ステータス'
      />
      <Button
        color='danger'
        onClick={() => {
          setParams({ status: undefined, search: undefined });
          setSearchText('');
        }}
      >
        クリア
      </Button>
    </div>
  );
};
